import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import DarkModePage from '@components/modules/dark-mode/page'
import ErrorBoundary from '@components/shared/error-boundary'
import Layout from '@components/shared/layout'

require('@utils/mixpanel')

if (module.hot) {
  module.hot.accept()
}

const root = ReactDOM.createRoot(document.getElementById('root'))

root.render(
  <ErrorBoundary>
    <BrowserRouter>
      <Layout basicHeader>
        <DarkModePage />
      </Layout>
    </BrowserRouter>
  </ErrorBoundary>
)
